import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { allowedCategories } from './TaskConfig'

export enum TaskCategory {
    Animals = 'ANIMAL_PREVENTION',
    Maintenance = 'MAINTENANCE',
    DeIcing = 'DE_ICING',
    RescueService = 'RESCUE_SERVICE',
    Inspection = 'INSPECTION',
    LVP = 'LVP',
    HBA = 'HBA',
    Refuelling = 'REFUELLING',
    Terminal = 'TERMINAL',
}

export const taskCategories = EnumValues.getValues<TaskCategory>(TaskCategory).filter(q =>
    allowedCategories.includes(q),
)

export const translateTaskCategory = (t: TFunction) =>
    translateEnum(t)(TaskCategory, 'task-category')
